export default __webpack_public_path__ + "static/media/Western.4f6fe6db.png";